import { Link } from "react-router-dom";
import { cleaners } from "@/mocks/landing";

export default function Cleaners() {
  return (
    <section id="cleaners" className="bg-background-50 px-4 md:px-10 py-20 md:py-32">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
        <div>
          <p className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-foreground-600 mb-4">
            <span className="w-6 h-px bg-foreground-400"></span>
            Meet the team
          </p>
          <h2 className="font-heading text-4xl md:text-6xl font-medium text-foreground-950 leading-[1.05] max-w-3xl">
            Real people. Vetted, trained,<br />and fairly paid.
          </h2>
        </div>
        <Link
          to="/cleaners"
          className="inline-flex items-center gap-2 text-foreground-900 text-sm font-medium hover:text-primary-600 whitespace-nowrap"
        >
          Browse all 320 cleaners
          <i className="ri-arrow-right-up-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
        {cleaners.map((c) => (
          <article
            key={c.id}
            data-product-shop
            className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300 transition-colors"
          >
            <div className="relative h-72 md:h-80 overflow-hidden">
              <img
                src={c.image}
                alt={c.name}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
              <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 bg-background-50/95 backdrop-blur-sm text-foreground-900 text-xs font-medium px-3 py-1.5 rounded-full">
                <i className="ri-star-fill text-secondary-500"></i>
                {c.rating}
              </span>
              <span className="absolute top-3 right-3 inline-flex items-center gap-1 bg-primary-500 text-background-50 text-xs font-medium px-3 py-1.5 rounded-full">
                {c.rate}
              </span>
            </div>
            <div className="p-5">
              <h3 className="font-heading text-foreground-950 text-lg font-medium leading-tight">{c.name}</h3>
              <p className="text-foreground-600 text-sm mt-1">{c.role}</p>
              <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200">
                <span className="text-xs text-foreground-700">{c.jobs} completed jobs</span>
                <Link
                  to="/cleaners"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 hover:bg-primary-600 transition-colors"
                  aria-label={`See ${c.name}'s profile`}
                >
                  <i className="ri-arrow-right-line text-sm"></i>
                </Link>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}